import { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, ArrowLeft } from "lucide-react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { RESOURCES } from "../data/site";
import { Eyebrow } from "../components/Reveal";

export default function Resources() {
  useEffect(() => {
    document.title = "Maintenance Resources | Fleet Maintenance Insights, Mobile Maintenance";
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Navbar />
      <main className="bg-mm-base pt-32 pb-24 min-h-screen">
        <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
          <Link to="/" className="inline-flex items-center gap-2 text-gray-400 hover:text-mm-green transition-colors font-mono text-xs uppercase tracking-widest mb-10" data-testid="back-home">
            <ArrowLeft size={14} /> Back to site
          </Link>
          <Eyebrow>Knowledge Base</Eyebrow>
          <h1 className="mt-4 font-heading font-black uppercase tracking-tight text-white text-5xl sm:text-6xl lg:text-7xl leading-[0.9] max-w-4xl">
            Fleet Maintenance <span className="text-mm-green">Resources</span>
          </h1>
          <p className="mt-6 max-w-2xl text-gray-400 leading-relaxed">
            Practical insights on preventative maintenance, cooling systems, and building
            resilient fleet programs, from the team that&apos;s performed over a million PMs.
          </p>

          <div className="mt-16 grid gap-px bg-mm-green/15 border border-mm-green/15 md:grid-cols-2 lg:grid-cols-3">
            {RESOURCES.map((r, i) => (
              <motion.div
                key={r.slug}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
              >
                <Link to={`/resources/${r.slug}`} data-testid={`resource-card-${i}`} className="group flex flex-col h-full bg-mm-surface p-8 hover:bg-mm-panel transition-colors duration-300">
                  <div className="flex items-center justify-between font-mono text-[11px] uppercase tracking-widest text-mm-green">
                    <span>{r.category}</span>
                    <span className="text-gray-500">{r.read}</span>
                  </div>
                  <h2 className="mt-5 font-heading font-bold uppercase text-2xl text-white leading-tight group-hover:text-mm-green transition-colors flex-1">
                    {r.title}
                  </h2>
                  <p className="mt-4 text-sm text-gray-400 leading-relaxed">{r.excerpt}</p>
                  <span className="mt-6 inline-flex items-center gap-2 text-mm-green font-mono text-xs uppercase tracking-widest">
                    Read Article <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
                  </span>
                </Link>
              </motion.div>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
